import { UseFormRegister } from "react-hook-form";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import { CommonSelectType } from "../../../../../types/common/basic";
import { useUser } from "../../../../../util/userContext/UserContext";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {
    useReadExchangeType1SelectBox,
    useReadExchangeType2SelectBox,
    useReadExchangeType3SelectBox
} from "../../../../customer/correspondent/detail/hooks";
import {
    useReadExchangeRateUnitSelectBoxApi
} from "../../../../customer/correspondent/detail/hooks/useReadExchangeRateUnitSelectBox";
import { useReadWonUnitSelectBox } from "../../../../customer/correspondent/detail/hooks/useReadWonUnitSelectBox";
import { useReadCurrencyTypeSelectBox } from "../../create/hooks/useReadCurrencyTypeSelectBox";
import { usePriceSetter } from "../hooks/usePriceSetter";
import { OrdersDetailSubjectType } from "../interface";
import React, { useMemo } from "react"; //내부수정
import moment from "moment"; //내부수정


interface Props {
    isPcsDelivery?: boolean
}

interface PropsUpper {
    ordersSubject: OrdersDetailSubjectType
    btnToggleModify: () => any
    wonUnit: string | null
    register: UseFormRegister<OrdersDetailSubjectType>
}

interface PropsLower {
    isDeadline: boolean | undefined
}

export default function Tab2({
                                 isPcsDelivery,
                                 ordersSubject,
                                 btnToggleModify,
                                 wonUnit,
                                 register,
                                 isDeadline
                             }: Props & PropsUpper & PropsLower) {

                                const { user } = useUser();
    const {data: currencyList} = useReadCurrencyTypeSelectBox()
    const {data: exchangeTypeSelect1} = useReadExchangeType1SelectBox();
    const {data: exchangeTypeSelect2} = useReadExchangeType2SelectBox();
    const {data: exchangeTypeSelect3} = useReadExchangeType3SelectBox();
    const {data: exchangeRateUnitSelect} = useReadExchangeRateUnitSelectBoxApi();
    const {data: wonUnitSelect} = useReadWonUnitSelectBox();

    const {
        applyCurrencyValue,
        applyWonUnitValue,
        isNanSumValue,
        sumValue
    } = usePriceSetter(wonUnit, ordersSubject.newDExchangeRate);

    const isKRW = ordersSubject.newPCurrency === 100000000;

    // 내부수정: 기준일 조건에 따라 날짜 계산
    const startAt = useMemo(() => {
        const condition = ordersSubject.exchangeRateCondition1;
        if (!condition || condition == "200") return moment().format("YYYY-MM-DD");
        if (condition == "201" || condition == "204") return moment().startOf("month").format("YYYY-MM-DD");
        if (condition == "202") return moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD");
        return "";
    }, [ordersSubject.exchangeRateCondition1]);

    const endAt = useMemo(() => {
        const condition = ordersSubject.exchangeRateCondition1;
        if (!condition || condition == "200") return moment().format("YYYY-MM-DD");
        if (condition == "201" || condition == "204") return moment().format("YYYY-MM-DD");
        if (condition == "202") return moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD");
        return "";
    }, [ordersSubject.exchangeRateCondition1]);

    return <>
        <div className="content_wrap">
            <div className="table_top">
                <h6 className="table_stats">환율 정보</h6>
                <div className="table_toolbar">
                    {!isPcsDelivery &&
                        <AuthorityChecker authorityNames={!isDeadline ? ['shipmentWriteYn'] : ['endWriteYn']}>
                            <button className="btn btn-secondary w-100px" onClick={btnToggleModify}>수정</button>
                        </AuthorityChecker>
                    }
                </div>
            </div>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        {/* 내부수정: 환율 환종 자리 변경 */}
                        <th style={{width: "16.66%"}}>환종</th>
                        <td className="p-4px">
                            <select className="form-select" value={ordersSubject.newPCurrency ?? 0} disabled>
                                {currencyList?.map((item: CommonSelectType) => {
                                    return <option value={item.id}>{item?.name}</option>;
                                })}
                            </select>
                        </td>
                        <th style={{width: "16.66%"}}>환율</th>
                        <td style={{width: "33.33%"}}><DisplayNumber value={ordersSubject.newDExchangeRate}/></td>
                        
                    </tr>
                    <tr>
                        <th>기준일</th>
                        <td className="p-4px">
                            <select className="form-select" value={ordersSubject.exchangeRateCondition1 ?? 0} disabled>
                                <option value={undefined} hidden></option>
                                {exchangeTypeSelect1?.map((item) => {
                                    return <option value={item.id}>{item?.name}</option>;
                                })}
                            </select>
                        </td>
                        <td colSpan={2} className="p-4px">
                            <div className="d-flex justify-content-between align-items-center">
                                <input type="date"
                                       className="form-control"
                                       max="9999-12-31"
                                       disabled
                                       value={startAt}
                                />
                                <span className="txt_range mx-2">~</span>
                                <input type="date"
                                       className="form-control"
                                       max="9999-12-31"
                                       disabled
                                       value={endAt}
                                />
                                <button className="btn btn-info btn_search ms-2" disabled>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>기준일 메모</th>
                        <td colSpan={3}>{ordersSubject.exchangeDateMemo}</td>
                    </tr>
                    <tr>
                        <th>환율 지정 조건</th>
                        <td colSpan={3} className="p-4px">
                            <div className="d-flex align-items-center">
                                <select className="form-select" value={ordersSubject.exchangeRateCondition2 ?? 0}
                                        disabled>
                                    <option value={undefined} hidden></option>
                                    {exchangeTypeSelect2?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                                <select className="form-select ms-1" value={ordersSubject.exchangeRateCondition3 ?? 0}
                                        disabled>
                                    <option value={undefined} hidden></option>
                                    {exchangeTypeSelect3?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                                <select className="form-select ms-1" value={ordersSubject.exchangeRateUnit ?? 0}
                                        disabled>
                                    <option value={undefined} hidden></option>
                                    {exchangeRateUnitSelect?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>원화 단가 단위</th>
                        <td colSpan={3} className="p-4px">
                            <select className="form-select"
                                    value={wonUnit ?? ""}
                                    {...register("wonUnit")}
                                    disabled={Number(user?.inOutFlag) === 1}
                                    >
                                <option value={""}>선택</option>
                                {wonUnitSelect?.map((item) => {
                                    return <option value={item.id}>{item?.name}</option>;
                                })}
                            </select>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="content_wrap">
            <div className="table_top">
                <h6 className="table_stats">수주 품목</h6>
                <div className="table_toolbar">
                </div>
            </div>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    <thead>
                    <tr>
                        {/* 내부수정: 사이즈 고정 해제 
                        <th style={{width: "10%"}}>제품군</th>
                        <th style={{width: "20%"}}>품목</th>
                        <th style={{width: "20%"}}>규격</th>
                        <th style={{width: "12.5%"}}>단가</th>
                        <th style={{width: "12.5%"}}>원화 단가</th>
                        <th style={{width: "10%"}}>수량</th>
                        <th style={{width: "15%"}}>금액</th> */}
                        <th style={{width: "10%"}}>제품군</th>
                        <th>품목</th>
                        <th style={{width: "13%"}}>규격</th>
                        <th style={{width: "8%"}}>단가</th>
                        {!isKRW && <th style={{width: "8%"}}>원화 단가</th>}
                        <th style={{width: "8%"}}>수량</th>
                        <th style={{width: "10%"}}>매출액</th>
                        {!isKRW && <th style={{width: "10%"}}>원화 매출액</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {ordersSubject.list.length !== 0
                        ? ordersSubject.list.map((el, idx) =>
                            <tr>
                                <td className="text-center">{el.productGroupName}</td>
                                <td>{el.newTxtNmItem}</td>
                                <td>{el.new_txt_standard}</td>
                                <td className="text-end"><DisplayNumber value={el.new_d_unitprice}/></td>
                                {!isKRW && <td className="text-end"><DisplayNumber value={applyCurrencyValue(el.new_d_unitprice)}/></td>}
                                <td className="text-end"><DisplayNumber value={el.new_i_qty}/></td>
                                {/* 내부수정: 매출액(통화 원본) / 원화매출액 컬럼 추가 */}
                                <td className="text-end"><DisplayNumber value={el.new_d_total}/></td>
                                {!isKRW && <td className="text-end"><DisplayNumber value={applyWonUnitValue(el.new_d_won)}/></td>}
                            </tr>
                        )
                        : <EmptyTableRow colSpan={8}/>
                    }
                    </tbody>
                    {/* 내부수정: 합계 행 조정 */}
                    <tfoot>
                        {!isDeadline
                            ? <tr>
                                <td className="text-start grey" colSpan={isKRW ? 4 : 5}></td>
                                <td className="text-end">
                                    {isNanSumValue(ordersSubject.list.map(el => el.new_i_qty)) ? <>-</> :
                                        <DisplayNumber value={Number(sumValue(ordersSubject.list.map(el => el.new_i_qty)))}/>}
                                </td>
                                <td className="text-end">
                                    {isNanSumValue(ordersSubject.list.map(el => el.new_d_total)) ? <>-</> :
                                        <DisplayNumber value={Number(sumValue(ordersSubject.list.map(el => el.new_d_total)))}/>}
                                </td>
                                {!isKRW &&
                                    <td className="text-end">
                                        {isNanSumValue(ordersSubject.list.map(el => el.new_d_won)) ? <>-</> :
                                            <DisplayNumber value={applyWonUnitValue(Number(sumValue(ordersSubject.list.map(el => el.new_d_won))))}/>}
                                    </td>
                                }
                            </tr>
                            : <tr>
                                <td className="text-center grey" colSpan={isKRW ? 4 : 5}>공급가액</td>
                                <td className="text-end">
                                    {isNanSumValue(ordersSubject.list.map(el => el.new_i_qty)) ? <>-</> :
                                        <DisplayNumber value={Number(sumValue(ordersSubject.list.map(el => el.new_i_qty)))}/>}
                                </td>
                                <td className="text-end">
                                    {isNanSumValue(ordersSubject.list.map(el => el.new_d_total)) ? <>-</> :
                                        <DisplayNumber value={Number(sumValue(ordersSubject.list.map(el => el.new_d_total)))}/>}
                                </td>
                                {!isKRW &&
                                    <td className="text-end">
                                        {isNanSumValue(ordersSubject.list.map(el => el.new_d_won)) ? <>-</> :
                                            <DisplayNumber value={applyWonUnitValue(Number(sumValue(ordersSubject.list.map(el => el.new_d_won))))}/>}
                                    </td>
                                }
                            </tr>
                        }
                    </tfoot>

                    {/*
                    <tfoot>
                    {!isDeadline
                        ? <tr>
                            <td className="text-start grey" colSpan={5}></td>
                            <td className="text-end">{isNanSumValue(ordersSubject.list.map(el => el.new_i_qty)) ? <>-</> :
                                <DisplayNumber
                                    value={Number(sumValue(ordersSubject.list.map(el => el.new_i_qty)))}/>}</td>
                            <td className="text-end">{isNanSumValue(ordersSubject.list.map(el => el.new_d_won)) ? <>-</> :
                                <DisplayNumber
                                    value={applyWonUnitValue(Number(sumValue(ordersSubject.list.map(el => el.new_d_won))))}/>}</td>
                        </tr>
                        : <tr>
                            <td className="text-center grey" colSpan={5}>공급가액</td>
                            <td></td>
                            <td className="text-end">{isNanSumValue(ordersSubject.list.map(el => el.new_d_won)) ? <>-</> :
                                <DisplayNumber
                                    value={applyWonUnitValue(Number(sumValue(ordersSubject.list.map(el => el.new_d_won))))}/>}</td>
                        </tr>
                    }
                    </tfoot> */}
                </table>
            </div>
        </div>
    </>
}